module.exports = __webpack_public_path__ + "img/category_16.84e138a7.png";